import { ModuleRegistry } from "seneca-common/features/module/registry";

import { generateInitialUserAnswer, markAnswer } from "./logic/answers";
import { getModuleAssets, transformModuleAssets } from "./logic/assets";
import { generateContent } from "./logic/content";
import { canBeTested } from "./logic/tested";
import { initialiseState } from "./module-state";

export const MODULE_TYPE = "worked-example";
export type TYPE = "worked-example";
export { transformModuleAssets };

export const register = (moduleRegistry: ModuleRegistry) =>
  moduleRegistry
    .buildModule(MODULE_TYPE)
    .with.logic()
    .markAnswer(markAnswer)
    .generateContent(generateContent)
    .getModuleAssets(getModuleAssets)
    .canBeTested(canBeTested)
    .generateInitialUserAnswer(generateInitialUserAnswer)
    .generateInitialModuleState(initialiseState)
    .back.staticInformation()
    .displayName("Worked Example")
    .root.register();
